/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationsForServiceProvider } from '../../models/organizations-for-service-provider';

export interface GetServiceProviderOrganizations$Params {
}

export function getServiceProviderOrganizations(http: HttpClient, rootUrl: string, params?: GetServiceProviderOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationsForServiceProvider>> {
  const rb = new RequestBuilder(rootUrl, getServiceProviderOrganizations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationsForServiceProvider>;
    })
  );
}

getServiceProviderOrganizations.PATH = '/service-provider/organizations';
